<template>
	<template v-if="data">
		<section>
			<ButtonBack />

			<el-row class="titlerow" :class="data.case ? 'no-margin' : ''">
				<el-col :sm="12">
					<h1>{{ data.title }}</h1>
				</el-col>
				<el-col :sm="12">
					<div :class="`has-status has-status--${$getStateColor('complaint', data.state)}`">
						{{ $getStateFullLabel('complaint', data.state, false) }}
					</div>
				</el-col>
			</el-row>

			<RouterLink :to="'/fall/' + data.case?.id" :title="'Zugeordneten Fall anzeigen'" class="link" v-if="data.case && data.case.id">
				Zugeordneten Fall anzeigen
			</RouterLink>

			<TheBox :title="'Beschwerde Infos'" :hasDataGrid="true">
				<el-row>
					<el-col :sm="12" :xs="24">
						<el-form-item label="Beschwerdegrund:" prop="reason">
							<span>{{ data?.category.name }}</span>
						</el-form-item>

						<el-form-item label="Medium:" prop="medium">
							<span>{{ data?.medium.name }}</span>
						</el-form-item>

						<el-form-item label="Datum:">
							<span>{{ $formatDate(String(data.createdDate)) }}</span>
						</el-form-item>

						<el-form-item label="Rückfragen:">
							<span>{{ data.callbacks.length }}</span>
						</el-form-item>
					</el-col>

					<el-col :sm="12" :xs="24">
						<el-form-item label="Anhang:">
							<span>{{ data.files && data.files.length > 0 ? 'Ja' : 'Nein' }}</span>
						</el-form-item>

						<el-form-item label="ID:">
							<span>{{ data.hid }}</span>
						</el-form-item>

						<el-form-item label="Auf Website veröffentlicht:">
							<span>{{ data.publishedDate ? $formatDate(data.publishedDate) : 'Nein' }}</span>
						</el-form-item>
					</el-col>
				</el-row>
			</TheBox>

			<TheBox :title="'Beschwerde:'">
				<el-form-item label="" prop="text">
					<div class="text">{{ data.text }}</div>
				</el-form-item>
			</TheBox>
		</section>

		<DetailsMedia
			v-if="complaintFiles.length > 0"
			:files="complaintFiles"
			@addToFiles="null"
			@removeFromFiles="null"
			:showAddButton="false"
			:pageType="'beschwerde'"
		/>
		<DetailsLinks
			v-if="complaintLinks.length > 0"
			:links="complaintLinks"
			@addToLinks="null"
			@removeFromLinks="null"
			:showAddButton="false"
			:pageType="'beschwerde'"
		/>
	</template>
	<section v-else-if="loading === false">
		<ButtonBack />
		<el-alert :title="texts.general.emptyText" type="error" effect="dark" :closable="false" />
	</section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ButtonBack from '../components/buttons/ButtonBack.vue';
import TheBox from '../components/TheBox.vue';
import DetailsLinks from './sections/DetailsLinks.vue';
import DetailsMedia from './sections/DetailsMedia.vue';
import { ComplaintResponse, DetailFile, DetailLink } from '../types/types';
import { texts } from '../utils/texts';
import { getComplaint } from '@/requests/complaints';
import { startLoading, stopLoading } from '@/utils/loading/loadingHandler';

export default defineComponent({
	name: 'BeschwerdeDetailWerberatVorstand',
	data() {
		return {
			data: null as ComplaintResponse | null,
			loading: true,
			complaintFiles: [] as DetailFile[],
			complaintLinks: [] as DetailLink[],
		};
	},
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	components: {
		ButtonBack,
		TheBox,
		DetailsMedia,
		DetailsLinks,
	},
	computed: {
		texts() {
			return texts;
		},
	},
	methods: {
		async loadComplaint() {
			const loading = startLoading('#beschwerde');

			const result = await getComplaint(this.id);
			if (result.success) {
				this.data = result.data;

				this.complaintLinks = this.data.links.map((l) => {
					return { link: l, isNew: false } as DetailLink;
				});

				this.complaintFiles = this.data.files.map((f) => {
					return { file: f, isNew: false } as DetailFile;
				});
			}

			this.loading = false;
			stopLoading(loading);
		},
	},
	mounted() {
		this.loadComplaint();
	},
});
</script>
